import * as React from 'react';
import { signIn } from 'next-auth/client';
import { PortalAsideHeading } from '../../layout/Aside/PortalAsideHeading';
import { StoreContext } from '../../utils';
import { Store } from '../../store/Store';

export class LehrerAsideAnonym extends React.Component {
  static contextType = StoreContext;
  declare context: Store;

  render() {
    const { lehrer, gruppen } = this.context.lehrerStore;

    return (
      <>
        Sie sind nicht angemeldet.
        <button
          type="button"
          className="btn btn-transparent-white font-weight-bold"
          style={{ paddingLeft: 20, paddingRight: 20, marginRight: 20 }}
          onClick={signIn}
        >
          Anmelden
        </button>
        <PortalAsideHeading title="Gruppen" />
        <PortalAsideHeading title="Arbeitsaufträge" />
        <PortalAsideHeading title="Auswertungen" />
      </>
    );
  }
}
